export default __webpack_public_path__ + "static/media/coming_soon.3a454b71.PNG";